module.exports = __webpack_public_path__ + "a0ca767c33b2e33c187928ac68f9d92a.gif";